import { eType, Section } from "../Section";
import { GameWorld, eGameObject as eWorldObject } from "../../GameWorld";

export class SafeArea_0 extends Section {
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("safeArea_0", eType.safeArea_0, false);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        let world = GameWorld.instance;

        // Zem
        let e = world.getObjectNewEntity(eWorldObject.safeArea_0);
        e.setLocalPosition(0, 0, 0);
        e.reparent(this._root);

        // Kvetinace
        e = world.getObjectNewEntity(eWorldObject.flowerPot);
        e.setLocalPosition(-0.7, 0, -0.05);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.flowerPot);
        e.setLocalPosition(0.7, 0, -0.05);
        e.reparent(this._root);
    }
}